import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { optimizationApi, type SelfHealingAction } from '../../api/optimization';

export function SelfHealingCenterPage() {
  const [actions, setActions] = useState<SelfHealingAction[]>([]);
  const refresh = () => void optimizationApi.selfHealing().then(setActions);
  useEffect(() => { refresh(); }, []);
  const trigger = async () => { await optimizationApi.triggerHealing({ target: 'platform-worker', trigger: 'manual' }); refresh(); };
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Self-Healing Center</h1>
      <Link to="/optimization" className="mt-2 inline-block text-sm text-violet-700 hover:underline dark:text-violet-400">← Optimization Center</Link>
      <button type="button" onClick={trigger} className="mt-4 rounded bg-violet-600 px-4 py-2 text-sm text-white hover:bg-violet-700">Trigger Recovery</button>
      <ul className="mt-6 space-y-2">{actions.map((a) => (
        <li key={a.id} className="rounded border px-3 py-2 text-sm dark:border-slate-700">{a.target} · {a.action} · {a.recovered ? 'Recovered' : 'Failed'} · {a.trigger}</li>
      ))}{actions.length === 0 && <p className="text-sm text-slate-500">No healing actions yet.</p>}</ul>
    </div>
  );
}
